<div class="u-shadow-mini" style="position: relative;">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }} {{ timezone }}</h5>
				<span>
					<a
						href="#"
						class="datatable_download_icon"
						*ngIf="hasData && downloadConfiguration && downloadConfiguration.enableDownload"
						(click)="downloadCSV()"
						target="_blank"
					>
						<img class="downloadIcon" src="../../../../../assets/creative-assets/download.svg" />
					</a>
				</span>
			</div>
		</div>
		<div>
			<div class="daypart-chart" *ngIf="hasData">
				<div
					*ngFor="let impItem of dayPartData; let i = index"
					[ngStyle]="{ width: impItem.percentage + '%' }"
					class="daypart-chart-data-detail"
				>
					<div
						[ngStyle]="{ 'background-color': impItem.color }"
						class="daypart-chart-data"
						tooltip="<b><p class='primary-color'>{{ impItem.friendly_name }}</p><p>{{
							impItem.impressions | number
						}}</p><p>IMPRESSIONS</p></b>"
						[options]="tooltipOptions"
					></div>
				</div>
			</div>
			<div class="daypart-chart-legend" *ngIf="hasData">
				<div class="legend-data-detail-daypart">
					<div class="legend-detail-datpart">
						<!--    <div *ngFor="let impItemData of dayPartData; let i = index" [ngStyle]="{'width':impItemData.percentage+'%', 'white-space': 'nowrap'}">-->
						<!--		Older way kept it just incase if we need to get back to this version again-->
						<div *ngFor="let impItemData of dayPartData; let i = index" [ngStyle]="{ 'margin-right': '40px' }">
							<span [ngStyle]="{ 'background-color': impItemData.color }" class="legend-dot-daypart"></span>
							<span class="legend-name-daypart">{{ impItemData.daypart }}</span>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="!hasData" class="no-data-daypart">
				<div class="no-data-container-daypart no-data-text">No data Available</div>
			</div>
		</div>
	</div>
</div>
